import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, mediaQuery } from '../../common/styles/styleUtil';

interface ShowMoreButtonWrapperProps {
  isBeforeShowButtonWrapper?: boolean;
  marginTop?: number;
  padding?: number;
  display?: string;
  fadeOffset?: number;
  isOnSeoFooter?: boolean;
  isUsedInCommentSection?: boolean;
  isUsedInProjectPage?: boolean;
  isUsedForTag?: boolean;
}

export const ShowMoreButtonWrapper = styled.div<ShowMoreButtonWrapperProps>`
  background-color: #ffffff;
  width: 100%;
  margin-top: ${(props) => props.marginTop}px;
  padding: ${(props) => props.padding}px;
  position: relative;
  z-index: 0;

  ${ifProp(
    { isBeforeShowButtonWrapper: true },
    css<ShowMoreButtonWrapperProps>`
      &::before {
        display: ${(props) => props.display};
        content: '';
        position: absolute;
        z-index: 0;
        width: 100%;
        height: 40px;
        top: ${(props) => props.fadeOffset}px;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1)
        );
      }
    `,
  )};

  &.showMore {
    display: none;
  }

  ${ifProp(
    { isOnSeoFooter: true },
    css`
      margin-top: 0;
      background: none;
      &:before {
        display: none;
      }
    `,
  )};

  ${ifProp(
    { isUsedForTag: true },
    css`
      margin-top: 0;
      margin-left: 12px;
      padding: 1px 0px;
      width: auto;
      display: inline-block !important;
      background: none;
      &:before {
        display: none;
      }
    `,
  )};

  display: flex;
  > div {
    display: block;
    flex: 1;
  }
  a {
    display: inline-block;
    width: 360px;
    margin: 0 auto;
    padding: 14px 58px;
    color: #2b6ed2;
    font-size: 16px;
    font-weight: 500;
    border-radius: 3px;
    border: 1px solid #2b6ed2;
    text-align: center;
    .anticon {
      margin-left: 4px;
      font-size: 12px;
    }

    ${media.xs`
      width: 227px;
      padding: 14px 36px;
      ${ifProp(
        { isOnSeoFooter: true },
        css`
          padding: 0;
        `,
      )};
    `};

    ${ifProp(
      { isUsedInCommentSection: true },
      css`
        width: 236px;
        margin: 0;
        padding: 14px 16px;
        color: #797979;
        border: 1px solid #797979;
        @media (${mediaQuery.tablet}) {
          border: none;
          width: initial;
          padding: 0;
          color: #2b6ed2;
        }
        ${media.xs`
          width: 100%;
          margin: 0;
          padding: 14px 16px;
          color: #797979;
          border: 1px solid #797979;
        `};
      `,
    )};

    ${ifProp(
      { isUsedInProjectPage: true },
      css`
        border: none;
        width: initial;
        padding: 0;
        margin: 0;
        color: #2b6ed2;
        font-size: 14px;
        font-weight: 500;
        ${media.xs`
          width: initial;
          padding: 0;
        `};
      `,
    )};

    ${ifProp(
      { isOnSeoFooter: true },
      css`
        background-color: #20282e;
        margin-top: -6px;
        border-color: #20282e;
        text-align: left;
        margin: 0;
        padding: 0;
        color: #ffffff;
        font-size: 14px;
        width: auto;
        font-weight: normal;
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 40px;
          top: -60px;
          background: linear-gradient(
            to bottom,
            rgba(32, 40, 46, 0),
            rgba(32, 40, 46, 1)
          );
          ${media.xs`
          top: -50px;
          padding: 0;
        `};
        }
        &.expanded {
          &:before {
            display: none;
          }
        }
      `,
    )};

    ${ifProp(
      { isUsedForTag: true },
      css`
        border: none;
        width: initial;
        padding: 0;
        margin: 0;
        color: #2b6ed2;
        font-size: 14px;
        font-weight: 500;
        &:hover {
          text-decoration-line: underline;
        }
        ${media.xs`
          width: initial;
          padding: 0;
        `};
      `,
    )};
  }
`;
